import { isEmbedMode } from '@/utils/embedMode';

let socket;

const connect = (url, portalJwt, onMessage, onLoggedIn) => {
  // Skip WebSocket entirely when ehr-frontend is embedded in va-portal.
  // The embedded session only renders practice-setting and does not need
  // the chat/notification stream.
  if (isEmbedMode()) {
    console.log('🔌 WebSocket skipped: embed mode');
    return;
  }
  socket = new WebSocket(url);
  let pingInterval = null;

  socket.onopen = () => {
    console.log('WebSocket connected');
    // Authenticate with portal JWT (replaces DDP connect + login resume)
    send({ event: 'auth', token: portalJwt });
    // Keep connection alive with ping every 30 seconds
    pingInterval = setInterval(() => {
      if (socket?.readyState === WebSocket.OPEN) {
        send({ event: 'ping' });
      }
    }, 30000);
  };

  socket.onmessage = (event) => {
    const data = JSON.parse(event.data);
    if (data.event === 'pong') return;
    if (data.event === 'authenticated') {
      if (typeof onLoggedIn === 'function') onLoggedIn();
      return;
    }
    if (data.event === 'error') {
      console.error('WebSocket error:', data.message);
      return;
    }
    if (onMessage) onMessage(data);
  };

  socket.onclose = () => {
    console.log('WebSocket disconnected');
    clearInterval(pingInterval);
  };

  socket.onerror = (err) => {
    console.error('WebSocket error', err);
  };
};

const send = (data) => {
  if (socket && socket.readyState === WebSocket.OPEN) {
    socket.send(JSON.stringify(data));
  } else {
    console.warn('WebSocket not open');
  }
};

const disconnect = () => {
  if (socket) {
    socket.close();
  }
};

export default {
  connect,
  send,
  disconnect
};
